export default __webpack_public_path__ + "static/media/bending.23f3b6ae.png";